import { render, staticRenderFns } from "./RemitaCollectionsReport.vue?vue&type=template&id=2f23bcc8&scoped=true&"
import script from "./RemitaCollectionsReport.vue?vue&type=script&lang=js&"
export * from "./RemitaCollectionsReport.vue?vue&type=script&lang=js&"
import style0 from "./RemitaCollectionsReport.vue?vue&type=style&index=0&id=2f23bcc8&lang=scss&scoped=true&"
import style1 from "./RemitaCollectionsReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23bcc8",
  null
  
)

export default component.exports